import { findRecords } from '@/api/project/element';
import { ObjectDetail } from '@/commons/interface/object-detail'
import { Record } from '@/commons/interface/project/info-detail';
import React, { useEffect, useState } from 'react'
import './object-detail-record.less'
import { Skeleton } from 'antd';
import dayjs from 'dayjs';
import classNames from 'classnames';

interface IProps {
    detail: ObjectDetail
}

export default function ObjectDetailRecordPanel(props: IProps) {
    const detail = props.detail;

    const [records, setRecords] = useState<Record[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        setLoading(true);
        findRecords().then(res => {
            let red = res.data || []
            setRecords(red);
        }).finally(() => {
            setLoading(false)
        })
    }, [])

    const getTypeName = (type: number) => {
        if (type == 1) {
            return '正常';
        } else if (type == 2) {
            return '故障';
        } else if (type == 3) {
            return '维修中';
        }
    }

    return (
        <div className='object-detail-record-container'>
            <Skeleton loading={loading}>
                {records.map(record => (
                    <div className='object-record-item'>
                        <div className='title ellipsis'>{record.title}</div>
                        <div className='date'>{dayjs(record.gmtCreate).format('YYYY-MM-DD')}</div>
                        <div className={classNames({
                            'tag': true,
                            'normal': record.type == 1,
                            'error': record.type == 2,
                            'warning': record.type == 3,

                        })}>
                            <span>{getTypeName(record.type)}</span>
                        </div>
                    </div>
                ))}
            </Skeleton>
        </div>
    )
}
